import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { useHeaderHeight } from 'hooks';
import { rem } from 'design-system/values';
const Hero = ({ title, subTitle, topPadding, style, centered, OffBlack, }) => {
    const headerHeight = useHeaderHeight();
    return (<View style={[
            topPadding && { paddingTop: headerHeight },
            centered && styles.centered,
            style,
        ]}>
      <Text Text-24 {...(OffBlack ? { OffBlack: true } : { White: true })} style={centered ? styles.titleCentered : styles.title} centered={centered}>
        {title}
      </Text>
      {Boolean(subTitle) && (<Text TextThin-16 {...(OffBlack ? { Secondary: true } : { White: true })} style={centered ? styles.subTitleCentered : styles.subTitle} centered={centered}>
          {subTitle}
        </Text>)}
    </View>);
};
const styles = StyleSheet.create({
    centered: {
        alignItems: 'center',
    },
    title: {
        paddingEnd: rem(32),
    },
    titleCentered: {
        paddingHorizontal: rem(32),
    },
    subTitle: {
        marginTop: rem(4),
    },
    subTitleCentered: {
        marginTop: rem(4),
        paddingHorizontal: rem(32),
    },
});
export default Hero;
